// extracted by mini-css-extract-plugin
module.exports = {"color-white":"#FFFFFF","colorWhite":"#FFFFFF","main":"U3KPf","oppositeGenderLinkWrapper":"_1Bj7l"};